import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { SharedServicesModule } from '../../shared/services/shared.services.module';
import { LogOutModule } from '../log-out/log-out.module';
import { SideNavNgComponent } from './side-nav.component';

@NgModule({
  declarations: [SideNavNgComponent],
  imports: [CommonModule, SharedServicesModule, LogOutModule],
  exports: [SideNavNgComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SideNavNgModule {}
